module.exports = __webpack_public_path__ + "ax.no1.0c824dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ax.no1.jpg
// module id = wvVP
// module chunks = 0